import { useFormContext } from 'react-hook-form';
import { ISignUpFormData } from '../../../domain/models/ISignUpFormData';

export function useSignUpFormContext() {
	return useFormContext<ISignUpFormData>();
}
